import { ErrorBoundary } from '@sentry/react'
import { WorkflowPropertyValue } from 'components/WorkflowPropertyValue/WorkflowPropertyValue'
import { useWorkflow } from 'screens/ArticleViewWrapper/components/WorkflowProvider/WorkflowProvider'
import { PropertyValue as BasePropertyValue, Props } from '../PropertyValue/PropertyValue'
import Styles from './PropertyValue.module.scss'

const PropertyValue = ({ property, assignee, ...rest }: Props) => {
  const { property: workflowProperty, enabled } = useWorkflow()

  if (!enabled) {
    return <BasePropertyValue {...rest} property={property} assignee={assignee} />
  }

  if (!workflowProperty?.id) {
    return null
  }

  if (workflowProperty.id === property.id && assignee) {
    return (
      <div className={Styles.workflowPropertyWrapper}>
        <WorkflowPropertyValue assignee={assignee} />
      </div>
    )
  }

  return <BasePropertyValue {...rest} property={property} assignee={assignee} />
}

const PropertyValueContainer = (props: Props) => (
  <ErrorBoundary>
    <PropertyValue {...props} />
  </ErrorBoundary>
)

export { PropertyValueContainer as PropertyValue }
